'use es6';

export const LAYOUT = 'layout';
export const CUSTOM_WIDGET = 'customWidget';
export const GLOBAL_WIDGET = 'globalWidget';
export const TEMPLATE = 'template';
export const RAW_ASSET = 'rawAsset';